export const STEPS = {
  CHOOSE_SERVICE: "Choose Service",
  PAYMENT: "Payment",
};
